import { Injectable } from '@angular/core';
import * as Constants from '../globals/constants';
import { Helper } from '../utilities/helper';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  private helper = new Helper();
  private RESOURCES: any;

  constructor() {
    this.resources = this.helper.deepCopyObject(Constants.SETTINGS.STARTING_RESOURCES);
  }

  get resources(): any {
    return this.RESOURCES;
  }

  set resources(value: any) {
    this.RESOURCES = value;
  }

  public addResource(type, amount) {
    this.RESOURCES[type] += amount;
  }

  public addFreeAcres(amount) {
    this.addResource('freeAcres', amount);
    this.addResource('acres', amount);
    this.addResource('baseAcres', amount);
  }

  public getResource(type) {
    return this.RESOURCES[type];
  }

  public setResource(type, amount) {
    this.RESOURCES[type] = amount;
  }

  public haveResource(resources) {
    let canBeBought = true;
    const resourceList = Object.entries(resources);
    resourceList.forEach((resource) => {
      if (this.RESOURCES[resource[0]] < resource[1]) {
        canBeBought = false;
      }
    });
    return canBeBought;
  }

  public payResource(resources) {
    const canBeBought = this.haveResource(resources);
    if (canBeBought) {
      this.removeResource(resources);
    }
    return canBeBought;
  }

  public removeResource(resources) {
    const resourceList = Object.entries(resources);
    resourceList.forEach((resource) => {
      // @ts-ignore
      this.RESOURCES[resource[0]] -= resource[1];
      if ( this.RESOURCES[resource[0]] < 0) {
        this.RESOURCES[resource[0]] = 0;
      }
    });
  }

  public calculatePowerEfficiency() {
    const ratio = this.RESOURCES.power / (this.RESOURCES.acres - this.RESOURCES.freeAcres);
    if (ratio < .9) {
      return .9;
    } else if (Constants.SINGLETON_TECH.STATE.zero_point_energy) {
      if (ratio < 1.50 ) {
        return ratio;
      } else {
        return 1.50;
      }
    } else if (Constants.SINGLETON_TECH.STATE.fusion_energy) {
      if (ratio < 1.25 ) {
        return ratio;
      } else {
        return 1.25;
      }
    } else if (Constants.SINGLETON_TECH.STATE.renewable_energy) {
      if (ratio < 1.15 ) {
        return ratio;
      } else {
        return 1.15;
      }
    } else if (ratio < 1.1) {
      return ratio;
    } else {
      return 1.1;
    }
  }

  public reset() {
    this.resources = this.helper.deepCopyObject(Constants.SETTINGS.STARTING_RESOURCES);
  }
}
